import React from 'react';
import { Button } from '@thd-olt-component-react/core-ui';
import styles from './sign-in.module.scss';

const CreateAccountCardContent = () => {
  return (
    <div>
      <ul className={styles['sign-in__create-account-list']}>
        <li className={styles['sign-in__create-account-list-item']}>Save more with exclusive offers</li>
        <li className={styles['sign-in__create-account-list-item']}>Track orders, save receipts</li>
        <li className={styles['sign-in__create-account-list-item']}>Get 5% off subscription orders</li>
      </ul>
      <Button role="button" tag="a" href="/auth/view/signin?redirect=/&ref=null">Create an Account</Button>
    </div>
  );
};

export { CreateAccountCardContent };